import React from 'react';
import { Building2 } from 'lucide-react';
import { officesCall } from './officesApi';
import { OfficeSelect } from './OfficeSelect';

export const PatientOfficeMover = ({ patient, offices, onMoved, toast }) => {
  const current = patient.officeId && offices.some((o) => o.id === patient.officeId)
    ? patient.officeId : offices.find((o) => o.isPrimary)?.id;
  const move = async (officeId) => {
    try {
      await officesCall(`/${officeId}/patients`, { method: 'POST', body: JSON.stringify({ patientIds: [patient.id] }) });
      onMoved(officeId);
      toast({ title: 'Office updated', description: `${patient.firstName} ${patient.lastName} now belongs to ${offices.find((o) => o.id === officeId)?.name}` });
    } catch (e) {
      toast({ title: 'Could not change office', description: e.message, variant: 'destructive' });
    }
  };
  return (
    <span className="inline-flex items-center gap-1 text-sm font-normal" data-testid="patient-office-mover">
      <Building2 className="w-4 h-4 text-emerald-600" />
      <OfficeSelect offices={offices} value={current} onChange={move} testId="patient-office-select" className="h-8" />
    </span>
  );
};
